/**
 * Created by hiago on 28/01/15.
 */
angular.module('eficienciaFiscalModule')
    .directive('cbkTree', function () {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                nodes: '=',
                onClick: '=?',
                icon: '@'
            },

            controller: ['$scope', '$compile', function ($scope, $compile) {
                this.init = function (element, scope) {
                    var template = ''
                        + '<span ng-if="node.nodes" title="{{node.open? \'Click para abrir\' : \'Click para fechar\'}}" ng-click="node.open = !node.open;">'
                        + '     <i class="glyphicon glyphicon-folder-open" ng-if="node.open"></i>'
                        + '     <i class="glyphicon glyphicon-folder-close" ng-if="!node.open"></i>'
                        + '     {{node.name}}'
                        + '</span>'
                        + '<div class="childNodes slide-animation" ng-show="node.open">'
                        + '     <cbk-tree-nodes nodes="node.nodes"></cbk-tree-nodes>'
                        + '</div>'
                        + '<span ng-if="!node.nodes" ng-click="onClick(node)"><i ng-show="icon" class="{{icon}}"></i> {{node.name}}</span>';

                    scope.onClick = $scope.onClick ? $scope.onClick : angular.noop;
                    scope.icon = $scope.icon;

                    element.parent().html($compile(template)(scope))
                }
            }],
            template: ''
            + '<div class="tree smart-form">'
            + '     <cbk-tree-nodes nodes="nodes"></cbk-tree-nodes>'
            + '</div>'
        }
    })
    .
    directive('cbkTreeNodes', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                nodes: '=',
                open: '&?'
            },
            template: ''
            + '<ul ng-init="open = [];">'
            + '     <li class="parent_li" ng-repeat="node in nodes">'
            + '         <cbk-tree-node node="node"></cbk-tree-node>'
            + '     </li>'
            + '</ul>'
        }
    })
    .directive('cbkTreeNode', function () {
        return {
            restrict: 'E',
            require: '^?cbkTree',
            scope: {
                node: '='
            },
            link: function (scope, element, attrs, controller) {
                controller.init(element, scope);
            }
        }
    });
